import React, { useState, useCallback, memo } from 'react';
import PdfWorker from './PdfWorker';
import PdfPreviewSection from './PdfPreviewSection';

/**
 * PdfSilentRunner - Die "Brandschutzmauer" Architektur.
 * Diese Komponente kapselt Generierung und Anzeige an einem Ort,
 * um den State-Loop zum Haupt-Modal zu unterbrechen.
 */
const PdfSilentRunner = memo(({ payload }) => {
    const [localPdfUrl, setLocalPdfUrl] = useState(null);
    const [isInternalGenerating, setIsInternalGenerating] = useState(false);

    // Diese URL verlässt niemals diese Komponente -> Loop unmöglich
    const handleUrlReady = useCallback((url) => {
        if (!url) return;
        setLocalPdfUrl(url);
        setIsInternalGenerating(false);
    }, []);

    // Wir überwachen Änderungen am Payload, um den Ladestatus lokal zu setzen
    // (Zusätzlich zur Steuerung durch den Parent)
    React.useEffect(() => {
        if (payload) {
            setIsInternalGenerating(true);
        }
    }, [payload]);

    return (
        <>
            {/* Der Generator - Erhält einen Key basierend auf dem Payload, um bei Änderungen frisch zu starten */}
            <PdfWorker 
                key={payload}
                payload={payload} 
                onUrlReady={handleUrlReady} 
            />

            {/* Die Anzeige - direkt hier eingebettet */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                <PdfPreviewSection 
                    pdfUrl={localPdfUrl} 
                    loading={isInternalGenerating || !localPdfUrl} 
                />
            </div>
        </>
    );
});

PdfSilentRunner.displayName = 'PdfSilentRunner';

export default PdfSilentRunner;
